<template>
  <div class="ls-table-opration-component flex items-center">
    <!-- 单个按钮 -->
    <div
      v-for="(item, index) in config"
      :key="item.command"
      :class="itemClass(index)"
    >
      <el-tooltip
        :content="item.tooltip"
        placement="top"
        :disabled="tooltipDisabled(item)"
      >
        <span
          v-if="item.type == 'btn'"
          class="ls-click-text flex items-center"
          :class="commandDisable(item)"
          :style="commandStyle(item)"
          @click.stop="handleCommand(item.command, item)"
        >
          {{ item.lable }}
          <img class="icon" v-if="item.icon" :src="item.icon" alt="" />
        </span>
        <el-dropdown
          v-if="item.type == 'dropdown'"
          @command="handleCommand($event, item)"
          @visible-change="handleVisible($event, index)"
          trigger="hover"
          placement="bottom-start"
          :show-timeout="100"
          :disabled="item.disabled"
        >
          <span
            class="el-dropdown-link ls-click-text"
            @click.stop="(e) => e.preventDefault()"
          >
            {{ item.lable }}
            <i :class="arrowDirection(index)" class="text-[12px] font-[500]" v-if="!item.hideIcon"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="mItem in item.menu"
              :key="mItem.command"
              :command="mItem.command"
              :disabled="mItem.disabled"
            >
              {{ mItem.lable }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-else>-</div>
      </el-tooltip>
    </div>
  </div>
</template>
<!--
  操作配置示例如下
  [
    // 文案按钮
    {
      type: 'btn',
      lable: '续费',
      command: 'renew'
      disabled: true, // 是否禁用
      tootip: '为什么禁用', // 禁用之后的tooltip内容，不传则不展示tooltip,
      purview:'2', 没有操作权限时传 “ - ” 时，为了保持样式居中，为width，单位为em。
    },
    // 下单菜单
    {
      type: 'dropdown',
      lable: '操作',
      disabled: true, // 是否禁用
      tootip: '为什么禁用', // 禁用之后的tooltip内容，不传则不展示tooltip
      menu: [
        {
          lable: '菜单一',
          command: 'one'
        },
        {
          lable: '菜单二',
          command: 'two'
        },
      ]
    }
  ]
 -->
<script>
export default {
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    data: {
      type: [Array, Object, String, Number],
      default: "",
    },
    index: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      dropdownVisible: false,
      dropdownVisibleIndex: "",
    };
  },
  methods: {
    // 是否有左边分界线
    itemClass(index) {
      if (index != 0) {
        return "before-line";
      }
    },
    handleVisible(visible, index) {
      this.dropdownVisible = visible;
      this.dropdownVisibleIndex = index;
      this.$emit("visibleChange",visible, this.data, this.index);
    },
    arrowDirection(index) {
      if (this.dropdownVisible && this.dropdownVisibleIndex == index) {
        return "el-icon-arrow-up";
      } else {
        return "el-icon-arrow-down";
      }
    },
    tooltipDisabled(data) {
      if (data.tooltip && data.tooltip != "") {
        return false;
      } else {
        return true;
      }
    },
    commandDisable(data) {
      if (data.disabled) {
        return "disabled";
      }
    },
    commandStyle(data) {
      if(data.purview){
        return `width:${data.purview}em;justify-content: center;`
      }
    },
    // 下拉操作
    handleCommand(command, data) {
      if (data.disabled) return;
      this.$emit("command", command, this.data, this.index);
    },
  },
};
</script>

<style lang="less" scoped>
.ls-table-opration-component {
  .before-line {
    position: relative;
    padding-left: 17px;
    display: flex;
    align-items: center;
    &::before {
      content: "";
      width: 1px;
      height: 12px;
      background-color: #dcdee0;
      position: absolute;
      left: 8px;
    }
  }
  .icon {
    width: 12px;
    margin-left: 5px;
  }
  .disabled {
    cursor: not-allowed;
    color: #bbb;
  }
}
</style>